module.exports = __webpack_public_path__ + "media/images/draginstruction-b6c7740b13afab9e42e3a7fe22e8ff26.png";